import contactUs from "./contactUs";
import subscribe from "./subscribe";
import getNewsAndEvents from "./getNewsAndEvents";
import getProperties from "./getProperties";
import bookValuation from "./bookValuation";
import requestInfo from "./requestInfo";
import registerInterest from "./registerInterest";

export default class Api {
  static BASE_URL = "/wp-json/api";

  static fetch = async (options) => {
    const { endpoint, method = "GET", body, okStatus = 200 } = options;

    let response;

    try {
      response = await fetch(`${Api.BASE_URL}/${endpoint}`, {
        method: method.toUpperCase(),
        body: body ? JSON.stringify(body) : null,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
      });
    } catch (e) {
      throw await Api.errorHandling(null, e);
    }

    if (response.status !== okStatus) {
      throw await Api.errorHandling(response);
    }

    return response;
  };

  static errorHandling = async (response, error = null) => {
    if (!response) {
      return {
        code: "internet_connection",
        message: "Please check your internet connection and try again",
        validation: [],
        error,
      };
    }

    if (response.status === 500) {
      return {
        code: "internal_server_error",
        message:
          "Something went wrong while handling your request, please try again",
        validation: [],
        response,
      };
    }

    // const body = await response.json();
    // const errorCode = body.code

    return {
      code: "error",
      message: "Something went wrong",
      validation: [],
      response,
    };
  };

  static contactUs = contactUs(Api.fetch);
  static bookValuation = bookValuation(Api.fetch);
  static requestInfo = requestInfo(Api.fetch);
  static subscribe = subscribe(Api.fetch);
  static getNewsAndEvents = getNewsAndEvents(Api.fetch);
  static getProperties = getProperties(Api.fetch);
  static registerInterest = registerInterest(Api.fetch);
}
